/**
 *  페이지 이름
 */
export const VERSION_PAGE_NAME = {
  VERSION_LIST: '버전 전체 리스트',
  VERSION_CREATE: '버전 등록',
  VERSION_EDIT: '버전 편집',
};

/**
 *  버전 상세 페이지 타입
 */
export const VERSION_DETAIL_PAGE_TYPE = {
  /**
   *  등록
   */
  CREATE: 0,
  /**
   *  편집
   */
  EDIT: 1,
};

/**
 *  버전 상세 페이지 패널 name
 */
export const VERSION_DETAIL_PAGE_PANEL_NAME = {
  /**
   *  카테고리
   */
  VER_TYPE: 'ver-type',
  /**
   *  버전 서비스 정보
   */
  VER_INFO: 'ver-info',
};

/**
 *  버전 데이터 타입
 */
export const VERSION_TYPE = {
  /**
   *  안드로이드
   */
  ANDROID: 0,
  /**
   *  ios
   */
  IOS: 1,
  /**
   *  ONE
   */
  ONE: 2,
  /**
   *  ADMIN
   */
  ADMIN: 3,
};

/**
 *  버전 타입 TEXT
 */
export const VERSION_TYPE_TEXT = {
  [VERSION_TYPE.ANDROID]: '안드로이드',
  [VERSION_TYPE.IOS]: 'IOS',
  [VERSION_TYPE.ONE]: 'ONE',
  [VERSION_TYPE.ADMIN]: 'ADMIN',
};

/**
 * 버전 타입 셀렉트 리스트
 */
export const VERSION_TYPE_SELECT_LIST = [
  {
    id: VERSION_TYPE.ANDROID,
    name: VERSION_TYPE_TEXT[VERSION_TYPE.ANDROID],
  },
  {
    id: VERSION_TYPE.IOS,
    name: VERSION_TYPE_TEXT[VERSION_TYPE.IOS],
  },
  {
    id: VERSION_TYPE.ONE,
    name: VERSION_TYPE_TEXT[VERSION_TYPE.ONE],
  },
  {
    id: VERSION_TYPE.ADMIN,
    name: VERSION_TYPE_TEXT[VERSION_TYPE.ADMIN],
  },
];

/**
 *  버전 강제 업데이트 TYPE
 */
export const VERSION_FORCE_UPDATE_TYPE = {
  /**
   *  강제 아님
   */
  NOT_FORCE: 0,
  /**
   *  강제 업데이트 해야함
   */
  FORCE: 1,
};

/**
 *  버전 강제 업데이트 TEXT
 */
export const VERSION_FORCE_UPDATE_TEXT = {
  [VERSION_FORCE_UPDATE_TYPE.NOT_FORCE]: 'X',
  [VERSION_FORCE_UPDATE_TYPE.FORCE]: 'O',
};

/**
 * 버전 강제 업데이트 셀렉트 리스트
 */
export const VERSION_FORCE_UPDATE_SELECT_LIST = [
  {
    id: VERSION_FORCE_UPDATE_TYPE.NOT_FORCE,
    name: VERSION_FORCE_UPDATE_TEXT[VERSION_FORCE_UPDATE_TYPE.NOT_FORCE],
  },
  {
    id: VERSION_FORCE_UPDATE_TYPE.FORCE,
    name: VERSION_FORCE_UPDATE_TEXT[VERSION_FORCE_UPDATE_TYPE.FORCE],
  },
];

/**
 *  버전 조회 기간 타입
 */
export const VERSION_PERIOD_SEARCH_TYPE = {
  /**
   *  마켓에 등록한 날짜
   */
  MARKET_REGISTER_DATE: 0,
  /**
   *  릴리즈 된 날짜
   */
  RELEASE_DATE: 1,
  /**
   *  생성 날짜
   */
  CREATE_DATE: 2,
  /**
   *  수정 날짜
   */
  UPDATE_DATE: 3,
};

/**
 *  버전 조회 기간 타입 텍스트
 */
export const VERSION_PERIOD_SEARCH_TYPE_TEXT = {
  /**
   *  마켓에 등록한 날짜
   */
  [VERSION_PERIOD_SEARCH_TYPE.MARKET_REGISTER_DATE]: '마켓에 등록한 날짜',
  /**
   *  릴리즈 된 날짜
   */
  [VERSION_PERIOD_SEARCH_TYPE.RELEASE_DATE]: '릴리즈 된 날짜',
  /**
   *  생성 날짜
   */
  [VERSION_PERIOD_SEARCH_TYPE.CREATE_DATE]: '생성 날짜',
  /**
   *  수정 날짜
   */
  [VERSION_PERIOD_SEARCH_TYPE.UPDATE_DATE]: '수정 날짜',
};

/**
 *  버전 조회 기간 타입 리스트
 */
export const VERSION_PERIOD_SEARCH_TYPE_SELECT_LIST = [
  {
    id: VERSION_PERIOD_SEARCH_TYPE.MARKET_REGISTER_DATE,
    name: VERSION_PERIOD_SEARCH_TYPE_TEXT[VERSION_PERIOD_SEARCH_TYPE.MARKET_REGISTER_DATE],
  },
  {
    id: VERSION_PERIOD_SEARCH_TYPE.RELEASE_DATE,
    name: VERSION_PERIOD_SEARCH_TYPE_TEXT[VERSION_PERIOD_SEARCH_TYPE.RELEASE_DATE],
  },
  {
    id: VERSION_PERIOD_SEARCH_TYPE.CREATE_DATE,
    name: VERSION_PERIOD_SEARCH_TYPE_TEXT[VERSION_PERIOD_SEARCH_TYPE.CREATE_DATE],
  },
  {
    id: VERSION_PERIOD_SEARCH_TYPE.UPDATE_DATE,
    name: VERSION_PERIOD_SEARCH_TYPE_TEXT[VERSION_PERIOD_SEARCH_TYPE.UPDATE_DATE],
  },
];

/**
 *  기간 검색 버튼 리스트 (확장)
 */
export const VERSION_SEARCH_PERIOD_BUTTON_LIST = [
  {
    id: 0,
    name: '오늘',
    value: 0,
  },
  {
    id: 1,
    name: '1일',
    value: -1,
  },
  {
    id: 2,
    name: '2일',
    value: -2,
  },
  {
    id: 3,
    name: '3일',
    value: -3,
  },
  {
    id: 4,
    name: '7일',
    value: -7,
  },
  {
    id: 5,
    name: '10일',
    value: -10,
  },
  {
    id: 6,
    name: '20일',
    value: -20,
  },
  {
    id: 7,
    name: '30일',
    value: -30,
  },
  {
    id: 8,
    name: '100일',
    value: -100,
  },
  {
    id: -1,
    name: '전체',
    value: null,
  },
];

export const DATE_PICKER_VERSION_PLACEHOLDER_TEXT = 'YYYY년 M월 D일 H시 m분 s초';

/**
 *  버전 관리에서 메모 최대 글자수
 */
export const MAXIMUM_NUMBER_OF_VERSION_MEMO_TEXT = 2000;
